import { render, staticRenderFns } from "./ImportacaoStratws.vue?vue&type=template&id=2423ac5c&scoped=true"
import script from "./ImportacaoStratws.vue?vue&type=script&lang=js"
export * from "./ImportacaoStratws.vue?vue&type=script&lang=js"
import style0 from "./ImportacaoStratws.vue?vue&type=style&index=0&id=2423ac5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423ac5c",
  null
  
)

export default component.exports